export default function () {
  return this.imageHeight / this.rotatedInternalImageHeight
}
